import Vue from 'vue'
import VueRouter from 'vue-router'
import Launch from '@/views/launch/Launch.vue'
import Login from '@/views/launch/Login.vue'
import Profile from '@/views/me/Profile.vue'
import WebPages from '@/views/webpages/router.js'
// import Main from '../ui/main.vue'
import message from '@/data/message/router.js'
import systemLog from '@/data/systemLog/router.js'
import fbGrabedPost from '@/data/fbGrabedPost/router.js'
import igGrabedPost from '@/data/igGrabedPost/router.js'
import post from '@/data/post/router.js'
import postTag from '@/data/postTag/router.js'
import author from '@/data/author/router.js'
import webInfo from '@/data/webInfo/router.js'
import contentTemplate from '@/data/contentTemplate/router.js'
import user from '@/data/user/router.js'

import qa from '@/data/qa/router.js'
import qaGroup from '@/data/qaGroup/router.js'
import homeBanner from '@/data/homeBanner/router.js'
import order from '@/data/order/router.js'
import product from '@/data/product/router.js'
import productTag from '@/data/productTag/router.js'
import productCategory from '@/data/productCategory/router.js'
import productCategoryGroup from '@/data/productCategoryGroup/router.js'

// 第二階段
import newHomeBanner from '@/data/newHomeBanner/router.js'
import store from '@/data/store/router.js'
import productInfo from '@/data/productInfo/router.js'
import productInfoTag from '@/data/productInfoTag/router.js'
import originInfo from '@/data/originInfo/router.js'
import originInfoProduct from '@/data/originInfoProduct/router.js'
import teamBuying from '@/data/teamBuying/router.js'

// 2022/12 改版
import coupon from '@/data/coupon/router.js'
import gift from '@/data/gift/router.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'launch',
    component: Launch
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  }
]

routes.push(...WebPages)
routes.push(...webInfo)
routes.push(...systemLog)
routes.push(...message)
routes.push(...post)
routes.push(...postTag)
routes.push(...author)
routes.push(...contentTemplate)
routes.push(...fbGrabedPost)
routes.push(...igGrabedPost)
routes.push(...user)

routes.push(...qa)
routes.push(...qaGroup)
routes.push(...homeBanner)
routes.push(...order)
routes.push(...product)
routes.push(...productTag)
routes.push(...productCategory)
routes.push(...productCategoryGroup)

// 第二階段
routes.push(...newHomeBanner)
routes.push(...store)
routes.push(...productInfo)
routes.push(...productInfoTag)
routes.push(...originInfo)
routes.push(...originInfoProduct)
routes.push(...teamBuying)

// 2022/12改版
routes.push(...coupon)
routes.push(...gift)

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
